import React from 'react';

interface ExternalSearchHighlightProps {
  html: string;
  highlightStart: string;
  highlightEnd: string;
}

const ExternalSearchHighlight = ({
  html,
  highlightStart,
  highlightEnd,
}: ExternalSearchHighlightProps) => {
  const retainSplitRegex = new RegExp(
    `(${highlightStart}.*?${highlightEnd})`,
    'g',
  );

  const matchRegex = new RegExp(`${highlightStart}(.*?)${highlightEnd}`);

  return (
    <>
      {html.split(retainSplitRegex).map((segment, i) => {
        const match = segment.match(matchRegex);

        if (match) {
          return (
            // eslint-disable-next-line react/no-array-index-key
            <em className="search-highlight" key={i}>
              {match[1]}
            </em>
          );
        }

        return segment;
      })}
    </>
  );
};

export default ExternalSearchHighlight;
